document.addEventListener('DOMContentLoaded', function () {
  function isShopifyMediaUrl(url) {
    if (!url) return false;
    return (
      url.includes('/cdn/shop/files/') ||
      url.includes('/cdn/shop/products/') ||
      url.includes('cdn.shopify.com/s/files/')
    );
  }

  function isExcludedArea(el) {
    return !!el.closest(
      '.list-payment, .footer-payment, .social-icons, header, .header, .site-header, .announcement-bar, .yv-footer-links'
    );
  }

  function isProtectableImage(img) {
    if (!img || img.tagName !== 'IMG') return false;

    const src = img.currentSrc || img.src || '';
    if (!isShopifyMediaUrl(src)) return false;
    if (img.classList.contains('icon')) return false;
    if (isExcludedArea(img)) return false;

    return true;
  }

  function getProtectableTargetImage(target) {
    if (!(target instanceof Element)) return null;

    if (target.matches('img') && isProtectableImage(target)) {
      return target;
    }

    const pictureImg = target.closest('picture')?.querySelector('img');
    if (pictureImg && isProtectableImage(pictureImg)) {
      return pictureImg;
    }

    const mediaWrapper = target.closest(
      [
        '[data-fancybox]',
        '.fancybox',
        '.product-video-link',
        '.product-page-images-gallery',
        '.product-page-images-slider',
        '.product-page-images-stacked',
        '.product__media',
        '.product-media',
        '.product-gallery',
        '.product-grid',
        '.card-wrapper',
        '.card__media',
        '.image-wrapper',
        'a[href*="/cdn/shop/"]'
      ].join(', ')
    );

    if (mediaWrapper) {
      const wrappedImg = mediaWrapper.querySelector('img');
      if (wrappedImg && isProtectableImage(wrappedImg)) {
        return wrappedImg;
      }
    }

    return null;
  }

  function bindImageProtection(root = document) {
    root.querySelectorAll('img').forEach(function (img) {
      if (!isProtectableImage(img)) return;
      if (img.dataset.protectionBound === 'true') return;

      img.dataset.protectionBound = 'true';
      img.classList.add('protect-image');
      img.setAttribute('draggable', 'false');

      const link = img.closest('a');
      if (link) {
        link.setAttribute('draggable', 'false');
      }
    });
  }

  document.addEventListener(
    'contextmenu',
    function (e) {
      const protectedImg = getProtectableTargetImage(e.target);
      if (protectedImg) {
        e.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (e) {
      const protectedImg = getProtectableTargetImage(e.target);
      if (protectedImg) {
        e.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'mousedown',
    function (e) {
      if (e.button !== 2) return;

      const protectedImg = getProtectableTargetImage(e.target);
      if (protectedImg) {
        e.preventDefault();
      }
    },
    true
  );

  bindImageProtection();

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches('img')) {
          bindImageProtection(node.parentElement || document);
        } else {
          bindImageProtection(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});